import { atom } from 'jotai';
import { AssemblyId, CuboidData, PartId } from '@/types';
import { StateMap } from '@/utils/stateMap';

export const colorByAssemblyId = atom<{ [assemblyId: AssemblyId]: number } | undefined>(undefined);

export const splitCuboidsByPartId = atom<StateMap<PartId, CuboidData[]>>(new StateMap<PartId, CuboidData[]>());

export const isolatedPartCuboids = atom<CuboidData[]>([]);
